//import Vue from 'vue'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
    async save (context, data) {
        return axios.post('/api/v1/setting/save', data)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


